var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecorationImageLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 257,
    viewBox: "0 0 513 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_10543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171 68.5332H0V189.323H171V68.5332Z",
    fill: "url(#paint0_linear_609_10543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.122 189.323C212.413 189.323 239.4 162.283 239.4 128.928C239.4 95.573 212.413 68.5332 179.122 68.5332C145.832 68.5332 118.845 95.573 118.845 128.928C118.845 162.283 145.832 189.323 179.122 189.323Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.123 172.404C203.087 172.404 222.514 152.94 222.514 128.928C222.514 104.917 203.087 85.4526 179.123 85.4526C155.158 85.4526 135.731 104.917 135.731 128.928C135.731 152.94 155.158 172.404 179.123 172.404Z",
    fill: "#FFD200",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.7 0H256.5V222.733H461.7V0Z",
    fill: "url(#paint1_linear_609_10543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 34.2666H307.8V257H513V34.2666Z",
    fill: "url(#paint2_linear_609_10543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.7 34.2666H307.8V222.733H461.7V34.2666Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.285 138.021C401.285 140.171 401.09 142.321 400.505 144.47C399.725 147.401 398.555 150.137 396.994 152.678C395.824 154.632 394.069 156.391 392.508 157.954C387.047 163.23 381.781 168.702 376.32 173.978C374.175 176.128 371.639 177.887 368.909 179.255C367.349 180.036 365.593 180.623 363.838 181.209C361.302 181.795 358.572 182.186 355.841 181.991C354.281 181.991 352.721 181.795 351.16 181.404C349.6 181.013 348.235 180.623 346.674 180.036C343.164 178.668 340.238 176.519 337.508 173.783C335.362 171.633 333.802 169.288 332.632 166.552C332.047 165.185 331.461 163.621 331.071 162.058C330.486 159.517 330.096 156.782 330.096 154.241C330.096 152.287 330.486 150.333 331.071 148.379C332.437 143.493 334.777 139.389 338.288 135.872C343.944 130.205 349.6 124.537 355.256 118.87C356.426 117.698 357.987 117.112 359.742 117.502C361.302 117.893 362.473 118.87 363.058 120.238C363.838 122.192 363.448 124.147 361.887 125.71C356.426 131.182 350.965 136.653 345.504 142.125C344.139 143.493 342.774 145.056 341.994 146.815C341.408 147.988 341.018 149.16 340.628 150.333C340.043 151.896 339.848 153.655 339.848 155.414C339.848 157.563 340.238 159.517 341.018 161.472C342.384 164.989 344.529 167.725 347.65 169.679C349.21 170.656 350.77 171.438 352.526 171.829C354.476 172.415 356.621 172.61 358.767 172.415C363.058 172.024 366.763 170.07 369.884 166.943C375.15 161.667 380.416 156.391 385.682 151.114C386.852 149.942 387.828 148.965 388.803 147.597C389.778 146.229 390.558 144.666 391.143 143.102C391.728 141.343 392.118 139.389 391.923 137.435C391.728 132.745 390.168 128.837 387.047 125.515C385.877 124.342 385.292 122.779 385.682 121.02C386.072 119.457 386.852 118.284 388.413 117.698C390.558 116.916 392.313 117.307 393.874 119.066C395.629 121.02 397.189 123.17 398.555 125.515C399.53 127.273 400.115 129.228 400.7 131.182C401.09 133.722 401.285 135.872 401.285 138.021Z",
    fill: "url(#paint3_linear_609_10543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.739 118.284C367.739 115.939 367.934 113.985 368.324 112.031C369.299 107.536 371.249 103.628 374.37 100.306C376.125 98.3517 378.076 96.593 380.026 94.6388C384.317 90.3396 388.608 86.0404 392.899 81.7412C394.849 79.787 396.995 78.2236 399.53 76.8557C401.285 75.8786 403.236 75.2923 404.991 74.7061C407.527 74.1198 409.867 73.729 412.403 73.729C414.158 73.729 415.913 73.9244 417.474 74.3153C420.204 74.9015 422.545 75.8786 424.885 77.2465C428.006 79.0053 430.541 81.3503 432.687 84.0862C434.247 86.0404 435.417 88.19 436.392 90.535C436.977 91.9029 437.367 93.4663 437.758 95.0296C438.343 97.3746 438.538 99.7197 438.343 102.065C438.148 104.019 437.953 105.778 437.562 107.732C436.977 110.272 435.807 112.617 434.442 114.962C433.077 117.112 431.516 119.066 429.761 120.825C424.3 126.297 418.839 131.768 413.378 137.24C412.208 138.413 410.647 138.999 408.892 138.608C407.332 138.217 406.161 137.24 405.576 135.677C404.796 133.722 405.186 131.964 406.746 130.4C412.207 124.929 417.669 119.457 423.325 113.985C424.69 112.617 426.055 111.054 427.03 109.295C427.616 108.123 428.006 106.95 428.396 105.778C428.981 103.823 429.176 101.869 428.981 99.9151C428.591 94.2479 425.86 89.7533 421.179 86.4312C419.814 85.4541 418.059 84.6724 416.498 84.2816C414.548 83.6953 412.403 83.4999 410.452 83.6953C408.112 83.8908 405.966 84.477 403.821 85.4541C402.065 86.4312 400.505 87.4083 399.14 88.7762C393.484 94.4434 387.828 100.11 382.172 105.778C380.416 107.536 379.051 109.491 378.076 111.836C377.101 114.376 376.711 117.112 376.906 119.848C377.296 124.147 379.051 127.664 381.977 130.596C384.122 132.941 383.537 136.654 380.611 138.022C378.856 138.999 376.711 138.608 375.15 137.045C373.2 135.09 371.64 132.941 370.469 130.4C369.689 128.837 369.104 127.274 368.519 125.515C368.129 123.17 367.739 120.629 367.739 118.284Z",
    fill: "url(#paint4_linear_609_10543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.338 128.5C191.939 128.5 179.55 140.913 179.55 156.342C179.55 140.913 167.162 128.5 151.763 128.5C167.162 128.5 179.55 116.087 179.55 100.658C179.55 116.087 192.055 128.5 207.338 128.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1 72.8165C348.439 72.8165 339.863 81.4099 339.863 92.0915C339.863 81.4099 331.286 72.8165 320.625 72.8165C331.286 72.8165 339.863 64.2231 339.863 53.5415C339.863 64.2231 348.519 72.8165 359.1 72.8165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.188 188.467C431.08 188.467 425.363 194.196 425.363 201.317C425.363 194.196 419.645 188.467 412.538 188.467C419.645 188.467 425.363 182.738 425.363 175.617C425.363 182.738 431.134 188.467 438.188 188.467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_609_10543",
    x1: 130.387,
    y1: 158.483,
    x2: 58.7398,
    y2: 128.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_609_10543",
    x1: 461.7,
    y1: 111.367,
    x2: 256.5,
    y2: 111.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_609_10543",
    x1: 513,
    y1: 145.633,
    x2: 307.8,
    y2: 145.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_609_10543",
    x1: 330.096,
    y1: 149.678,
    x2: 401.285,
    y2: 149.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_609_10543",
    x1: 367.739,
    y1: 106.229,
    x2: 438.416,
    y2: 106.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C837"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_10543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 257,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationImageLarge);
export default __webpack_public_path__ + "static/media/decoration-image-large.8bcba29fe6cc8d301e9af056a4841f0e.svg";
export { ForwardRef as ReactComponent };